import { Outlet } from "react-router-dom";

const Easy = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Easy;
